import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Footer from "../../components/Footer.js";
import Navbar from "../../components/Navbar.js";
import Switch from "react-switch";

import "react-phone-input-2/lib/style.css";

import ConnectWallet from "../../components/ConnectWallet";

import { toastAlert } from "../../helper/toastAlert";

import { numberFloatOnly } from "../../helper/custom";
import {
    settingsInfo,
    updatePrice,
    updateClaimFee,
    updatewithdrawAmount,
    updateIsPause,
    checkUSDT
} from "./settingsdetail"

export default function AutoPoolV1Settings(props) {

    const walletConnection = useSelector((state) => state.walletConnection);
    const navigate = useNavigate();


    const [isDisable1, setisDisable1] = useState(false);
    const [isDisable2, setisDisable2] = useState(false);
    const [isDisable3, setisDisable3] = useState(false);
    const [isDisable4, setisDisable4] = useState(false);
    const [isDisable5, setisDisable5] = useState(false);

    const [tokenPrice, settokenPrice] = useState("");
    const [fee, setfee] = useState("");
    const [minwithdraw, setminwithdraw] = useState("");
    const [owneraddress, setowneraddress] = useState("");
    const [ispause, setispause] = useState(false);
    const [currentPause, setcurrentPause] = useState(false);

    const [claimed, setclaimed] = useState(0);
    const [unclaimed, setunclaimed] = useState(0);

    useEffect(() => {
        loadSettings();
        //eslint-disable-next-line
    }, [walletConnection]);

    async function loadSettings() {
        if (walletConnection && walletConnection.address && walletConnection.address != "") {
            var { price, claimFee, minimum, owner, isPause } = await settingsInfo();
            console.log(owner, 'ownerownerownerowner', isPause)
            settokenPrice(price);
            setfee(claimFee);
            setminwithdraw(minimum);
            setowneraddress(owner);
            setispause(isPause);
            setcurrentPause(isPause);
        }


    }

    async function updateTokenPrice() {

        if (validation(tokenPrice)) {

            if (owneraddress && walletConnection.address && walletConnection.address.toLowerCase() == owneraddress.toLowerCase()) {
                setisDisable1(true)
                var { status, error } = await updatePrice(tokenPrice);
                console.log(status, "status");
                setisDisable1(false);
                if (status) {
                    toastAlert("success", "Successfully updated", 'settings')
                }
                else {
                    toastAlert("error", error, 'settings')
                }
            } else {
                toastAlert("error", "Please login into admin wallet", 'settings')
            }
        }

    }

    async function updateFee() {
        if (validation(fee)) {
            if (owneraddress && walletConnection.address && walletConnection.address.toLowerCase() == owneraddress.toLowerCase()) {
                setisDisable2(true)
                var { status, error } = await updateClaimFee(fee);
                setisDisable2(false);
                if (status) {
                    toastAlert("success", "Successfully updated", 'settings')
                } else {
                    toastAlert("error", error, 'settings')
                }
            } else {
                toastAlert("error", "Please login into admin wallet", 'settings')
            }
        }

    }


    async function updateMinWithdraw() {
        if (validation(minwithdraw)) {
            if (owneraddress && walletConnection.address && walletConnection.address.toLowerCase() == owneraddress.toLowerCase()) {
                setisDisable3(true)
                var { status, error } = await updatewithdrawAmount(minwithdraw);
                console.log(status, "status");
                setisDisable3(false);
                if (status) {
                    toastAlert("success", "Successfully updated", 'settings')
                } else {
                    toastAlert("error", error, 'settings')
                }
            } else {
                toastAlert("error", "Please login into admin wallet", 'settings')
            }
        }

    }

    function validation(amount) {
        var status = true;
        if (parseFloat(amount) == 0 || amount == "") {
            toastAlert("error", "Please enter valid price", 'settings')
            status = false;
        }
        return status;

    }

    const onChangeTokenPrice = async event => {

        var value = event.target.value;
        var status = numberFloatOnly(value);
        if (status) {
            settokenPrice(value)
        } else if (value === "" || !status) {
            settokenPrice("")
        }
    }
    const onChangefee = async event => {

        var value = event.target.value;
        var status = numberFloatOnly(value);
        if (status) {
            setfee(value)
        } else if (value === "" || !status) {
            setfee("")
        }
    }

    const onChangeminWithdraw = async event => {

        var value = event.target.value;
        var status = numberFloatOnly(value);
        if (status) {
            setminwithdraw(value)
        } else if (value === "" || !status) {
            setminwithdraw("")
        }
    }

    const handleChange = async checked => {
        setispause(checked);
    }

    async function UpdatePause() {
        if (currentPause != ispause) {
            if (owneraddress && walletConnection.address && walletConnection.address.toLowerCase() == owneraddress.toLowerCase()) {
                setisDisable4(true)
                var { status, error } = await updateIsPause(ispause);
                console.log(status, "status");
                setisDisable4(false);
                if (status) {
                    toastAlert("success", "Successfully updated", 'settings')
                } else {
                    toastAlert("error", error, 'settings')
                }
            } else {
                toastAlert("error", "Please login into admin wallet", 'settings')
            }
        } else {
            var msg = "Already contract is working";
            if (!currentPause) {
                msg = "Already contract is paused";
            }
            toastAlert("error", msg, 'settings')
        }

    }

    async function checkDetails() {
        setisDisable5(true)
        checkUSDT(setunclaimed, setclaimed, setisDisable5)
    }


    return (
        <div className="t_flx py-5 mt-3 d-block text-center box" >
            <h6 className="mb-4 pb-2" >Settings</h6>
            <div className="row" >
                <div className="col-lg-6 text-start mx-auto" >
                    <label className="mb-2" >Token Price(1QBT={tokenPrice}$)</label>
                    <div class="input-group mt-0 mb-3 w-100">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Token Price"
                            aria-label="Token Price"
                            aria-describedby="basic-addon2"
                            onChange={onChangeTokenPrice}
                            value={tokenPrice}
                        />
                    </div>
                    <div className="d-flex mb-3" >
                        {walletConnection && walletConnection.address !== "" && walletConnection.connect === "yes" ?
                            <button
                                className="primary_btn"
                                disabled={isDisable1}
                                onClick={() => updateTokenPrice()}
                            >Update{isDisable1 && <i className="fas fa-spinner fa-spin"></i>}
                            </button>
                            :
                            <button
                                className="primary_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#connect_wallet_modal"
                            >Update
                            </button>
                        }
                    </div>
                </div>
            </div>

            <div className="row" >
                <div className="col-lg-6 text-start mx-auto" >
                    <label className="mb-2" >Fee($)</label>
                    <div class="input-group mt-0 mb-3 w-100">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Fee"
                            aria-label="Fee"
                            aria-describedby="basic-addon2"
                            onChange={onChangefee}
                            value={fee}
                        />
                    </div>
                    <div className="d-flex mb-3" >
                        {walletConnection && walletConnection.address !== "" && walletConnection.connect === "yes" ?
                            <button
                                className="primary_btn"
                                disabled={isDisable2}
                                onClick={() => updateFee()}
                            >Update{isDisable2 && <i className="fas fa-spinner fa-spin"></i>}
                            </button>
                            :
                            <button
                                className="primary_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#connect_wallet_modal"
                            >Update
                            </button>
                        }
                    </div>
                </div>
            </div>

            <div className="row" >
                <div className="col-lg-6 text-start mx-auto" >
                    <label className="mb-2" >Minumum withdraw(USDT)</label>
                    <div class="input-group mt-0 mb-3 w-100">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Minumum withdraw"
                            aria-label="Minumum withdraw"
                            aria-describedby="basic-addon2"
                            onChange={onChangeminWithdraw}
                            value={minwithdraw}
                        />
                    </div>
                    <div className="d-flex mb-3" >
                        {walletConnection && walletConnection.address !== "" && walletConnection.connect === "yes" ?
                            <button
                                className="primary_btn"
                                disabled={isDisable3}
                                onClick={() => updateMinWithdraw()}
                            >Update{isDisable3 && <i className="fas fa-spinner fa-spin"></i>}
                            </button>
                            :
                            <button
                                className="primary_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#connect_wallet_modal"
                            >Update
                            </button>
                        }
                    </div>
                </div>
            </div>

            <div className="row" >
                <div className="col-lg-6 text-start mx-auto" >
                    <label className="mb-2" >Stop(Contract)</label>
                    <div class="input-group mt-0 mb-3 w-100">
                        <Switch onChange={handleChange} checked={ispause} />
                        {ispause && <p className="m-0 ms-2" >On</p>}
                        {!ispause && <p className="m-0 ms-2" >Off</p>}
                    </div>
                    <div className="d-flex mb-3" >
                        {walletConnection && walletConnection.address !== "" && walletConnection.connect === "yes" ?
                            <button
                                className="primary_btn"
                                disabled={isDisable3}
                                onClick={() => UpdatePause()}
                            >Update{isDisable4 && <i className="fas fa-spinner fa-spin"></i>}
                            </button>
                            :
                            <button
                                className="primary_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#connect_wallet_modal"
                            >Update
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
